import { useGetProfileImage } from '../../hooks';
import { COLORS } from '../../constants/style/color';
import { NavBarLabel, NavBarProfilePic } from './navbar.styled';
import Tooltip from '../tooltip';
import { selectParticipantId } from '../../pages/configuration/participantSignupSlice';
import { useSelector } from 'react-redux';

interface NavLogoType {
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>;
  data?: any;
}

const NavLogo = ({ handleRequest, data }: NavLogoType): JSX.Element => {
  const participantId = useSelector(selectParticipantId);
  const {
    data: ProfileImage,
    isLoading,
    status,
  } = useGetProfileImage(handleRequest, !!participantId);
  if (isLoading || status !== 'success') return <></>;
  return (
    <NavBarProfilePic>
      {(ProfileImage?.content as unknown as boolean) ? (
        <img
          src={`data:image/png;base64,${ProfileImage?.content ?? ''}`}
          alt={`${ProfileImage?.name ?? ''}`}
        />
      ) : (
        <Tooltip
          tooltipText={data?.companyName ?? ''}
          variant='dark'
          size='sm'
          placement='bottom-center'>
          <span>
            <NavBarLabel
              variant='h5'
              color={COLORS.DarkPurple}
              fontWeight={700}
              title={data?.companyName ?? ''}
            />
          </span>
        </Tooltip>
      )}
    </NavBarProfilePic>
  );
};

export { NavLogo };
